import React from "react";
import firebase from "firebase/app";
import 'firebase/storage';


export default  function Enviarecado(user,recado,remetente) {

  var rec = recado+" - "+remetente;

    var unit = firebase.firestore().collection("usuarios").doc(user).collection('recados').doc();


    
  unit.set({recado:rec, statusrecado: "novo", datarecado:firebase.firestore.Timestamp.fromDate(new Date())})
.then(() => {
console.log("locsaliza successfully updated!");

})
.catch((error) => {
  // The document probably doesn't exist.
  console.error("Error updating document: ", error);
});
return

}
export {Enviarecado}